module.exports = __webpack_public_path__ + "static/img/kn-Skiadi.644a575.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kn-Skiadi.jpg
// module id = XFbm
// module chunks = 1